import {
    DIC
} from '@/const/dic'
import {
    validateChinese,
    validateCapitalUnderline
} from '@/util/validate'
const pass = (rule, value, callback) => {
    if (value) {
        callback()
    } else {
        callback()
    }

}


export const engineerGoodsOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    border: true,
    expand: false,
    stripe: false,
    showHeader: true,
    // align: 'center',
    index: false,
    selection: true,
    menu: true,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    viewBtn: false,
    menuWidth: '300',
    labelWidth: '150',
    defaultSort:{
        prop: 'createTime',
        order: 'descending'
    },
    column: [
        {
            label: "商品名称",
            prop: "name",
            type: "input",
            search: true,
            rules: [{
                required: true,
                trigger: "blur",
                message: "请输入商品名称"
            }]
        },  
        {
            label: "单位",
            prop: "unit",
            rules: [{
                required: true,
                trigger: "blur",
                message: "请输入单位"
            }]
        },
        {
            label: "一级分类",
            prop: "firstClassifyId",
            hide: true, 
            formsolt: true,
            searchslot: true,
            rules: [{
                required: true,
                trigger: "blur",
                message: "请选择一级分类"
            }]
        },
        {
            label: "一级分类",
            prop: "firstClassifyName",
            type: "input",
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "二级分类",
            prop: "secondClassifyId",
            hide: true, 
            formsolt: true,
            searchslot: true,
            rules: [{
                required: true,
                trigger: "blur",
                message: "请选择二级分类"
            }]
        },
        {
            label: "二级分类",
            prop: "secondClassifyName",
            type: "input",
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "现有库存",
            prop: "goodsNumber",
            rules: [{
                required: true,
                trigger: "blur",
                message: "请输入现有库存"
            }]
        },
        // {
        //     label: "初始库存",
        //     prop: "initialNumber",
        //     addVisdiplay: false,
        //     editVisdiplay: false,
        //     rules: [{
        //         required: true,
        //         trigger: "blur",
        //         message: "请输入初始库存"
        //     }]
        // },
        {
            label: '配送方式',
            prop: 'dispatching',
            hide: true,
            formsolt: true
        },
        {
            label: "零售价",
            prop: "price",
            rules: [{
                required: true,
                trigger: "blur",
                message: "请输入零售价"
            }]
        },
        {
            label: "工程师价格",
            prop: "engineerPrice",
            rules: [{
                required: true,
                trigger: "blur",
                message: "请输入工程师价格"
            }]
        },
        {
            label: "监理价格",
            prop: "managerPrice",
            rules: [{
                required: true,
                trigger: "blur",
                message: "请输入监理价格"
            }]
        },
        {
            label: '省份',
            prop: 'province',
            type: 'select',
            hide: true,
            formsolt: true
        },
        {
            label: '城市',
            prop: 'city',
            type: 'select',
            hide: true,
            formsolt: true,
        },
        {
            label: '地区',
            prop: 'area',
            type: 'select',
            hide: true,
            formsolt: true,
        },
        {
            label: "平台抽成比例",
            prop: "platformRatio",
            rules: [{
                required: true,
                trigger: "blur",
                message: "请输入平台抽成比例"
            }]
        },
        {
            label: "配送费比例",
            prop: "distributionRatio",
            rules: [{
                required: true,
                trigger: "blur",
                message: "请输入配送费比例"
            }]
        },
        {
            label: "商品图片",
            prop: "img",
            span: 24,
            // hide: true,
            solt: true,
            formsolt: true,
            rules: [{
                required: true,
                trigger: "blur",
                message: "请上传商品图片"
            }]
        },
        {
            label: "创建时间",
            prop: "createTime",
            type: "datetime",
            sortable: true,
            format: "yyyy-MM-dd HH:mm:ss",
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: '商品状态',
            prop: 'status',
            type: "select",
            dicData: DIC.PRODUCT_WAREHOUSING_STATUS,
            addVisdiplay: false,
            editVisdiplay: false
        },
    ]
};